import React from "react";
import Skills from "./Skills";
import SectionHeader from "../../components/SectionHeader";
import profilePic from "../../assets/images/murad.jpg";

import "./about.scss";

export const About = () => {
  const subtitle = `"I have a passion for creating user experiences that are seamless, meaningful and impactful."`;

  return (
    <section className="about section" id="about" data-scroll-section>
      <div className="section-wrapper">
        <SectionHeader title="About." subtitle={subtitle} />
        <div className="about-content content">
          <div className="bio-wrapper">
            {/* <h3></h3> */}
            <div className="bio-body">
              <p>Hi there, </p>
              <p>
                My name is <b>Murad Muqbel</b>, a passionate junior Fullstack
                web developer from Jordan, currently based in Berlin Germany.
              </p>
              {/* <p>
                I am an IT graduate, but recently switched to the awesome world
                of web development.
              </p> */}
              {/* i spent the last 15+ years working in the Hospitality industry,
              and only */}
              <p>
                My interest in web development started few years back, when i
                had the opportunity to see the wonders one can make with HTML,
                CSS, and JS.
              </p>
              <p>
                this interest led me to start a one year Fullstack program at{" "}
                <a href="https://digitalcareerinstitute.org/" className="dci">
                  <span>DCI Berlin</span>
                </a>
                , where i am learning the fundamentals of programming, and how
                to develope ideas into sleek and functional web applications
                using the latest technologies like MongoDB, Express, React,
                Node, and many more.
              </p>
              <p>
                i am passionate about learning new technologies and and how to
                harness them to build a better and more efficient web
                application.
              </p>
              {/* <p>
                i think wep applications have a great role in changing peoples
                lives for the better and i want to contribute to this change i
                am always looking for new ways to improve the lives of people.
                and how harnessing the power of the web to create a better user
                experience
              </p> */}
              {/* <p>
                I'm currently on the journey to becoming a Fullstack Web
                Developer where I can work with more technologies , programming
                languages and develop more inspiring projects.
              </p> */}
            </div>
          </div>
          <div className="image-container">
            <div className="image-wrapper">
              <div className="profile-image">
                <img src={profilePic} alt="profile" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Skills />
    </section>
  );
};
